import "./hb-post.module.css";
import { html } from "lit-html";
import { isPopup } from "../../global";

export default (user) => html`
    <div
        id="hb-post"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h1
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        🩵 HeartBank® Post
                    </h1>
                    <aside>
                        <button id="hb-post-archive" class="hidden">
                            <svg
                                class="w-5 h-5 fill-sky-500 mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512">
                                <path
                                    d="M0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64zM32 176l448 0 0 240c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-240zm152 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z" />
                            </svg>
                        </button>
                        <span
                            id="hb-post-views"
                            class="hidden mr-1 text-sm text-gray-700 dark:text-gray-300">
                            <span class="font-bold">0</span>
                            Views
                        </span>
                        <button
                            type="button"
                            class="${isPopup
                                ? "hidden"
                                : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="hb-post">
                            <svg
                                class="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                            </svg>
                            <span class="sr-only">Close</span>
                        </button>
                    </aside>
                </div>
                <!-- Modal body -->
                <form
                    id="hb-post-form"
                    class="p-4 md:p-5 space-y-4 text-base leading-[2] text-gray-900 dark:text-white">
                    <div class="grid gap-4">
                        <div
                            id="hb-post-heading"
                            class="text-2xl font-black text-center mt-1"></div>
                        <div id="hb-post-title-container">
                            <label
                                for="hb-post-title"
                                class="inline-flex justify-between align-middle w-full mb-2 text-sm text-gray-900 dark:text-white">
                                <span class="text-base">🩵 Title</span>
                                <div>
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-post-title-magic">
                                        🪄
                                    </button>
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-post-title-paste">
                                        📋
                                    </button>
                                    <button
                                        type="button"
                                        id="hb-post-title-trash">
                                        🗑️
                                    </button>
                                </div>
                            </label>
                            <div class="relative w-full mb-4">
                                <div
                                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                    <svg
                                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 512 512">
                                        <path
                                            d="M461.2 18.9C472.7 24 480 35.4 480 48l0 416c0 12.6-7.3 24-18.8 29.1s-24.8 3.2-34.3-5.1l-46.6-40.7c-43.6-38.1-98.7-60.3-156.4-63l0 95.7c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96C57.3 384 0 326.7 0 256S57.3 128 128 128l84.5 0c61.8-.2 121.4-22.7 167.9-63.3l46.6-40.7c9.4-8.3 22.9-10.2 34.3-5.1zM224 320l0 .2c70.3 2.7 137.8 28.5 192 73.4l0-275.3c-54.2 44.9-121.7 70.7-192 73.4L224 320z" />
                                    </svg>
                                </div>
                                <input
                                    required
                                    autocomplete="on"
                                    type="text"
                                    id="hb-post-title"
                                    class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-sky-500 dark:focus:border-sky-500"
                                    placeholder="Announcement" />
                            </div>
                        </div>
                        <div id="hb-post-menu">
                            <label
                                id="hb-post-menu-pager"
                                class="hidden justify-between align-middle w-full mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <aside id="hb-post-menu-page">
                                    <span>0</span>
                                    <span>/</span>
                                    <span>0</span>
                                </aside>
                                <aside>
                                    <button
                                        type="button"
                                        id="hb-post-menu-previous"
                                        class="mr-3">
                                        <svg
                                            class="w-5 h-5 inline text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="currentColor"
                                            viewBox="0 0 256 512">
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                                        </svg>
                                    </button>
                                    <button
                                        type="button"
                                        id="hb-post-menu-next">
                                        <svg
                                            class="w-5 h-5 inline text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="currentColor"
                                            viewBox="0 0 256 512">
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M247.1 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L179.2 256 41.9 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" />
                                        </svg>
                                    </button>
                                </aside>
                            </label>
                            <div
                                class="w-full mb-0 inline-flex rounded-md shadow-xs"
                                role="group">
                                <button
                                    id="hb-post-menu-photo"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-sky-700 focus:z-10 focus:ring-2 focus:ring-sky-700 focus:text-sky-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-sky-500 dark:focus:text-white">
                                    Photo
                                </button>
                                <button
                                    id="hb-post-menu-short"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 hover:bg-gray-100 hover:text-sky-700 focus:z-10 focus:ring-2 focus:ring-sky-700 focus:text-sky-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-sky-500 dark:focus:text-white">
                                    Short
                                </button>
                                <button
                                    id="hb-post-menu-ai"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-sky-700 focus:z-10 focus:ring-2 focus:ring-sky-700 focus:text-sky-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-sky-500 dark:focus:text-white">
                                    Ai
                                </button>
                            </div>
                        </div>
                        <div id="hb-post-ai" class="hidden opacity-40">
                            <div class="relative w-full mb-4">
                                <div
                                    class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                    <svg
                                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 640 512">
                                        <path
                                            stroke="currentColor"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M256 0L576 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64l0-224c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l80 0 48 0 144 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128l96 0 0 256 0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32 160 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm0 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm0 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm336 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z" />
                                    </svg>
                                </div>
                                <input
                                    type="text"
                                    id="hb-post-ai-prompt"
                                    class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-sky-500 dark:focus:border-sky-500"
                                    placeholder="Enter Prompt for Cover Art" />
                                <button
                                    type="button"
                                    id="hb-post-ai-magic"
                                    type="button"
                                    class="absolute inset-y-0 end-0 flex items-center pe-3">
                                    <svg
                                        class="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="currentColor"
                                        viewBox="0 0 576 512">
                                        <path
                                            stroke="currentColor"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M263.4-27L278.2 9.8 315 24.6c3 1.2 5 4.2 5 7.4s-2 6.2-5 7.4L278.2 54.2 263.4 91c-1.2 3-4.2 5-7.4 5s-6.2-2-7.4-5L233.8 54.2 197 39.4c-3-1.2-5-4.2-5-7.4s2-6.2 5-7.4L233.8 9.8 248.6-27c1.2-3 4.2-5 7.4-5s6.2 2 7.4 5zM110.7 41.7l21.5 50.1 50.1 21.5c5.9 2.5 9.7 8.3 9.7 14.7s-3.8 12.2-9.7 14.7l-50.1 21.5-21.5 50.1c-2.5 5.9-8.3 9.7-14.7 9.7s-12.2-3.8-14.7-9.7L59.8 164.2 9.7 142.7C3.8 140.2 0 134.4 0 128s3.8-12.2 9.7-14.7L59.8 91.8 81.3 41.7C83.8 35.8 89.6 32 96 32s12.2 3.8 14.7 9.7zM464 304c6.4 0 12.2 3.8 14.7 9.7l21.5 50.1 50.1 21.5c5.9 2.5 9.7 8.3 9.7 14.7s-3.8 12.2-9.7 14.7l-50.1 21.5-21.5 50.1c-2.5 5.9-8.3 9.7-14.7 9.7s-12.2-3.8-14.7-9.7l-21.5-50.1-50.1-21.5c-5.9-2.5-9.7-8.3-9.7-14.7s3.8-12.2 9.7-14.7l50.1-21.5 21.5-50.1c2.5-5.9 8.3-9.7 14.7-9.7zM460 0c11 0 21.6 4.4 29.5 12.2l42.3 42.3C539.6 62.4 544 73 544 84s-4.4 21.6-12.2 29.5l-88.2 88.2-101.3-101.3 88.2-88.2C438.4 4.4 449 0 460 0zM44.2 398.5L308.4 134.3 409.7 235.6 145.5 499.8C137.6 507.6 127 512 116 512s-21.6-4.4-29.5-12.2L44.2 457.5C36.4 449.6 32 439 32 428s4.4-21.6 12.2-29.5z" />
                                    </svg>
                                </button>
                            </div>
                            <div class="relative w-full">
                                <img
                                    id="hb-post-ai-image"
                                    class="w-full h-auto"
                                    src="https://raw.githubusercontent.com/333eco/stock.333.eco/main/vault/g/3/3.gif" />
                            </div>
                        </div>
                        <div id="hb-post-photo" class="hidden">
                            <div
                                class="flex items-center justify-center w-full">
                                <label
                                    id="hb-post-photo-upload"
                                    for="hb-post-photo-file"
                                    class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                    <div
                                        class="flex flex-col items-center justify-center pt-5 pb-6">
                                        <div
                                            class="hidden w-full mb-10 bg-gray-200 rounded-full dark:bg-gray-500">
                                            <div
                                                id="hb-post-photo-progress"
                                                class="bg-green-600 text-xs font-medium text-green-100 text-center p-0.5 leading-none rounded-full"
                                                style="width: 0%">
                                                0%
                                            </div>
                                        </div>
                                        <svg
                                            class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 20 16">
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                        </svg>
                                        <p
                                            class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                                            <span class="font-semibold">
                                                Tap to upload
                                            </span>
                                            or take a photo
                                        </p>
                                        <p
                                            class="text-xs text-gray-500 dark:text-gray-400">
                                            Your image will be compressed and
                                            optimized
                                        </p>
                                    </div>
                                    <input
                                        id="hb-post-photo-file"
                                        type="file"
                                        accept="image/*"
                                        class="hidden" />
                                </label>
                            </div>
                            <div class="hidden relative w-full">
                                <img
                                    id="hb-post-photo-image"
                                    class="w-full h-auto" />
                                <button
                                    type="button"
                                    id="hb-post-photo-download"
                                    class="text-white absolute font-medium text-base top-3 left-1/2 -translate-x-1/2">
                                    Save B-Photo
                                </button>
                                <button
                                    type="button"
                                    id="hb-post-photo-remove"
                                    class="text-white absolute font-medium text-base bottom-3 left-1/2 -translate-x-1/2">
                                    Remove B-Photo
                                </button>
                            </div>
                        </div>
                        <div id="hb-post-short" class="hidden">
                            <div
                                class="flex items-center justify-center w-full">
                                <label
                                    id="hb-post-short-upload"
                                    for="hb-post-short-file"
                                    class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                    <div
                                        class="flex flex-col items-center justify-center pt-5 pb-6">
                                        <div
                                            class="hidden w-full mb-10 bg-gray-200 rounded-full dark:bg-gray-500">
                                            <div
                                                id="hb-post-short-progress"
                                                class="bg-green-600 text-xs font-medium text-green-100 text-center p-0.5 leading-none rounded-full"
                                                style="width: 0%">
                                                0%
                                            </div>
                                        </div>
                                        <svg
                                            class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 20 16">
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                        </svg>
                                        <p
                                            class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                                            <span class="font-semibold">
                                                Tap to upload
                                            </span>
                                            or capture a short
                                        </p>
                                        <p
                                            class="text-xs text-gray-500 dark:text-gray-400">
                                            Your video must be less than 10
                                            minutes
                                        </p>
                                    </div>
                                    <input
                                        id="hb-post-short-file"
                                        accept="video/*"
                                        type="file"
                                        class="hidden" />
                                </label>
                            </div>
                            <div class="relative w-full hidden">
                                <video
                                    preload="metadata"
                                    playsinline
                                    controls
                                    autoplay
                                    muted
                                    loop
                                    id="hb-post-short-video"
                                    class="w-full h-auto"></video>
                                <button
                                    type="button"
                                    id="hb-post-short-download"
                                    class="text-white absolute font-medium text-base top-3 left-1/2 -translate-x-1/2">
                                    Save B-Short
                                </button>
                                <button
                                    type="button"
                                    id="hb-post-short-remove"
                                    class="text-white absolute font-medium text-base bottom-3 left-1/2 -translate-x-1/2">
                                    Remove B-Short
                                </button>
                            </div>
                        </div>
                        <div>
                            <video
                                id="hb-post-cover"
                                playsinline
                                autoplay
                                muted
                                loop
                                class="hidden w-full h-auto"></video>
                        </div>
                        <div>
                            <label
                                for="hb-post-story"
                                class="w-full inline-flex items-center justify-between align-middle mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <span
                                    id="hb-post-story-from"
                                    class="hidden font-bold text-base">
                                    🩵 From
                                </span>
                                <span
                                    id="hb-post-story-author"
                                    class="text-base"></span>
                                <div id="hb-post-story-actions" class="hidden">
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-post-story-magic">
                                        🪄
                                    </button>
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-post-story-paste">
                                        📋
                                    </button>
                                    <button
                                        type="button"
                                        id="hb-post-story-trash">
                                        🗑️
                                    </button>
                                </div>
                            </label>
                            <section class="relative">
                                <textarea
                                    required2
                                    id="hb-post-story"
                                    rows="4"
                                    placeholder2="Optional: Write your story here to publish on the Aquarius™ Blockchain — freely and forever assessible to all humans and AI agents"
                                    class="resize-none block outline-0 p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-sky-500 focus:border-sky-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-sky-500 dark:focus:border-sky-500"></textarea>
                                <button
                                    class="hidden absolute bottom-0 left-2"
                                    type="button"
                                    id="hb-post-story-record">
                                    🎙️
                                </button>
                                <button
                                    class="hidden absolute bottom-0 right-2"
                                    type="button"
                                    id2="hb-post-story-magic">
                                    🪄
                                </button>
                            </section>
                        </div>
                        <div
                            id="hb-post-footer"
                            class="hidden justify-center -mt-2 w-full text-gray-400 text-sm">
                            <span
                                id="hb-post-footer-date"
                                class="text-xs"></span>
                        </div>
                    </div>
                    <!-- Modal footer: Mint Thank -->
                    <div
                        class="p-2 border-0 border-gray-200 rounded-b dark:border-gray-600">
                        <section
                            id="hb-post-external"
                            class="w-full flex items-center justify-between">
                            <button
                                id="hb-post-share"
                                type="button"
                                class="mr-1 text-white bg-sky-700 hover:bg-sky-800 focus:ring-4 focus:outline-none focus:ring-sky-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-sky-600 dark:hover:bg-sky-700 dark:focus:ring-sky-800">
                                Share B-Post
                            </button>
                            <button
                                id="hb-post-copy"
                                type="button"
                                class="ml-1 text-white bg-sky-700 hover:bg-sky-800 focus:ring-4 focus:outline-none focus:ring-sky-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-sky-600 dark:hover:bg-sky-700 dark:focus:ring-sky-800">
                                Copy B-Post
                            </button>
                        </section>
                        <div class="pt-3 flex flex-col gap-3">
                            <button
                                id="hb-post-thank"
                                type="submit"
                                class="hidden pt-3 text-white bg-sky-800 hover:bg-sky-900 focus:ring-4 focus:outline-none focus:ring-sky-400 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-sky-700 dark:hover:bg-sky-800 dark:focus:ring-sky-900"></button>
                            <button
                                id="hb-post-publish"
                                type="submit"
                                class="pt-3 text-white bg-sky-700 hover:bg-sky-800 focus:ring-4 focus:outline-none focus:ring-sky-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-sky-600 dark:hover:bg-sky-700 dark:focus:ring-sky-800"></button>
                        </div>
                    </div>
                    <div
                        id="hb-post-tokens"
                        class="hidden pt-2 mb-4 flex flex-col gap-3"></div>
                </form>
            </div>
        </div>
    </div>
`;
